export const EditPicture = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M20.4001 10.1323V6.60012C20.4001 5.27461 19.3256 4.20007 18 4.20007H6.00015C4.67464 4.20007 3.6001 5.27461 3.6001 6.60012V12.0001V13.5V17.4C3.6001 18.7255 4.67464 19.8001 6.00015 19.8001H11H13.4479"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.44003"
    />
    <path
      d="M20.0535 12.8565L16.0101 16.8999C15.7477 17.1623 15.6003 17.5182 15.6003 17.8892V18.926C15.6003 19.409 15.9918 19.8005 16.4748 19.8004L17.5116 19.8004C17.8826 19.8003 18.2385 19.653 18.5008 19.3906L22.5442 15.3472C22.8569 15.0345 22.886 14.5391 22.6165 14.1925L22.5664 14.1342L21.2901 12.8565C20.9486 12.5151 20.395 12.5151 20.0535 12.8565Z"
      stroke="currentColor"
      strokeWidth="1.44003"
    />
    <path
      d="M3.75073 12.5281C7.38691 11.9221 13.4472 13.1341 13.4472 19.8004"
      stroke="currentColor"
      strokeWidth="1.44003"
    />
    <circle cx="15.6003" cy="8.98715" r="1.9463" stroke="currentColor" strokeWidth="1.43977" />
  </svg>
);
